export default {
    prePayInfo: "/gateway/huilian/repayment/selectRepaymentPrePay",
    payCreate: "/gateway/huilian/repayment/agentPay",
};



// WEBPACK FOOTER //
// ./src/pages/carRentPayment/api.js